import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'TransferOfferNotification',
  props: {
    notification: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_RouterLink = _resolveComponent("RouterLink");
      const _component_i18n_t = _resolveComponent("i18n-t");
      return _openBlock(), _createBlock(_component_i18n_t, {
        keypath: "received_offer_for_player_x"
      }, {
        player: _withCtx(() => [_createVNode(_component_RouterLink, {
          class: "text-green-600 font-bold",
          to: {
            name: 'players.show',
            params: {
              id: __props.notification.payload.playerId
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.notification.payload.playerName), 1)]),
          _: 1
        }, 8, ["to"])]),
        _: 1
      });
    };
  }
});